/**
 * We’ve got three cases:
 * • RES customers with a given name only
 * • Business customers with company name only
 * • Business (ENT?) customers on behalf of a company (have both a given name and a company name, also, optionally, a userName)
 */
export type Customer = (
  | {
      name: string;
      companyName?: string;
    }
  | {
      name: undefined;
      companyName: string;
    }
) & {
  userName?: string;
  scn: string;
  basn?: string;
  segment: TCustomerSegment;
  priorityStatus?: boolean;
};

export type CustomerState = "LOADING" | "ANONYMOUS" | Customer;

export function isCustomer(state: CustomerState): state is Customer {
  return !!state && typeof state !== `string`;
}

export function isRes(state: CustomerState): state is Customer {
  return (
    isCustomer(state) &&
    !!(state.scn || state.basn) &&
    (state.segment || "res").toLowerCase() === "res"
  );
}

export type TCustomerSegment = "res" | "sme-person" | "sme-company";

export type TLanguage = "de" | "en" | "fr" | "it";

export type TFusionAppName = "swisscom_portal" | "pex" | "complan";
export type TFusionInstance = "a" | "b";
